const helper = {
  resolvers: {
    Query: {},
  },
};

export default helper;
